import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import { Toaster } from 'react-hot-toast';

export default function DetalleUser({ dataBascula, total }) {
    return (
        <>
            <Typography align="center" variant="h4" style={{ fontWeight: 'bold' }}color='primary'>Total de registros
                <Toaster
                    position="top-center"
                    fontWeight="10"
                    reverseOrder={false}
                    gutter={9}
                    containerClassName=""
                    containerStyle={{}}
                    toastOptions={{
                        // Define default options
                        className: '',
                        duration: 2000,
                        style: {
                            background: '#ffffff',
                            color: '#000',
                            fontSize: '15px'
                        },

                        // Default options for specific types
                        success: {
                            duration: 2000,
                            theme: {
                                primary: 'green',
                                secondary: 'black',
                            },
                        },
                    }}

                />
            </Typography>

            <Grid container style={{ marginTop: "1%" }} alignItems="center" justifyContent="center" spacing={4}>
                <Grid item>
                    <Grid item xs={12} sm container >
                        <Grid item xs container direction="column" >
                            <Grid item xs>
                                <Typography style={{ fontWeight: 'bold' }} component="p" align="center" variant="h2">
                                    {total}
                                </Typography>
                                <Typography align="center" variant="h5"></Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}